import { useState } from "react";

import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { useOutletApi } from "@/features/authentication";
import { OtherPaymentForm } from "@/features/other-payments";
import { getErrorMessage } from "@/features/shared";
import { PageContainer, useSnackbar } from "@/features/ui";

export const CreateOtherPayment = () => {
  const navigate = useNavigate();
  const outletApi = useOutletApi();
  const { showSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (data) => {
    try {
      setIsSubmitting(true);
      const { outletId, ...payload } = data;

      await outletApi.post("other-payments", payload, {
        headers: { "Outlet-Id": outletId },
      });

      showSnackbar("Pembayaran berhasil dibuat", "success");
      navigate("/general-ledger/other-payments");
    } catch (error) {
      showSnackbar(getErrorMessage(error, "Gagal membuat pembayaran"));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pembayaran"
      breadcrumbs={[
        { title: "Pembayaran", path: "/general-ledger/other-payments" },
        { title: "Buat" },
      ]}
    >
      <OtherPaymentForm
        onSubmit={handleSubmit}
        renderActionButton={() => (
          <Button
            type="submit"
            variant="contained"
            disabled={isSubmitting}
            size="large"
          >
            {isSubmitting ? "Menyimpan..." : "Simpan"}
          </Button>
        )}
      />
    </PageContainer>
  );
};
